import { Component, OnInit,ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {AlertaPremiumDialog} from '../alerta-premium';
import {AlertaSimplesDialog} from '../alerta-simples';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-shop-endereco',
  templateUrl: './shop-endereco.component.html',
  styleUrls: ['./shop-endereco.component.css']
})
export class ShopEnderecoComponent implements OnInit, OnDestroy {
  @ViewChild("numeroInput") meuInputNumero: ElementRef;
  arrMeusEnderecos: any[] =[]
  hideCL: boolean = false;
  // meuCarrinho: CartItem[];
  usuarioPremium: boolean = false;
  logradouro: any = '';
  numero: any = '';
  bairro: any = '';
  cidade: any = '';
  uf: any = '';
  novoEnd: boolean = false;
  titulo: any = '';
  cep: any = '';
  complemento: any = '';
  modoNE: boolean = false;
  itenFavorito: any = '';
  public maskCEP = [ /[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {
    if(this.tmaService.shopCheck){
      this.tmaService.eventoFS(true);
      this.carregarEnderecos();
      this.novoEnd = true;
    }
    else{
      this.router.navigate(['/pre-shop/uf']);
    }
    

  }
  ngOnDestroy(){
    this.tmaService.eventoFS(false);
  }
  showNE() :void{
    this.modoNE = true;
    this.novoEnd = true;
  }
  carregarEnderecos() : void{
    this.hideCL = false;
    var dadosBc = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarEnderecos(dadosBc)
    .subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.arrMeusEnderecos = qRes['meusEnderecos'];
        if(this.arrMeusEnderecos.length > 0){
          this.novoEnd = false;
          this.itenFavorito = this.arrMeusEnderecos[0].Id;
        }
      }
    })
  }

  digitouCEP(info: string) :void{
    console.log(info);
    console.log(info.replace(new RegExp("\\-", 'g'),"").length);
    //consultar cep
    if(info.replace(new RegExp("\\-", 'g'),"").replace(new RegExp("\\_", 'g'),"").length == 8){
      this.hideCL = false;
      console.log("buscando cep");
      var dadosIn = info.replace(new RegExp("\\-", 'g'),"").replace(new RegExp("\\_", 'g'),"") + '/json/';
      this.tmaService.buscarCEPVia(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        if(qRes['erro'] == true){
          this.hideCL = true;
        }
        else{
          this.hideCL = true;
          this.logradouro = qRes['logradouro'];
          this.bairro = qRes['bairro'];
          this.cidade = qRes['localidade'];
          this.uf = qRes['uf'];
          this.meuInputNumero.nativeElement.focus();
        }
      })
    }

    if(info.replace(new RegExp("\\-", 'g'),"").replace(new RegExp("\\_", 'g'),"").length == 0){
      this.logradouro = '';
      this.bairro = '';
      this.cidade = '';
      this.uf = '';
    }
  
    
  }
  excluir(idEnd : any) :void{
    const avisoIC =  this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {tituloAlerta: "Remover Endereço",   textoAlerta: "Deseja realmente excluir este endereço?", textoCancel: "Não", textoConfirm: "Sim", iconAlerta: "delete_outline"}
    });
    avisoIC.afterClosed().subscribe((result) =>{
      console.log(result);
      if(result == true){
        //server side
        this.hideCL = false;
        var dadosInX = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idendereco=' + idEnd;
        this.tmaService.removerEndereco(dadosInX)
        .subscribe((qRes) =>{
          console.log(qRes);
          this.hideCL = true;
          if(qRes['res'] == 'done'){
            this.carregarEnderecos();
          }
        })
      }
    });
  }
  goCheckout() :void{
    if(this.novoEnd){
      //enviar para o servidor o novo endereco,
      //alterar isso aqui para post

      if(this.cep == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite o CEP deste endereço', iconAlerta: 'warning' }
        });
        return;
      }
      if(this.logradouro == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite o logradouro deste endereço', iconAlerta: 'warning' }
        });
        return;
      }
      if(this.numero == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite o número deste endereço', iconAlerta: 'warning' }
        });
        return;
      }
      if(this.bairro == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite o bairro deste endereço', iconAlerta: 'warning' }
        });
        return;
      }

      if(this.cidade == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite a cidade', iconAlerta: 'warning' }
        });
        return;
      }

      if(this.uf == ''){
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor digite o UF', iconAlerta: 'warning' }
        });
        return;
      }
      this.cidade = this.modifiers(this.cidade);
      this.hideCL = false;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        tituloendereco: '',
        logradouro: this.logradouro,
        numero: this.numero,
        cep: this.cep,
        bairro: this.bairro,
        cidade: this.cidade,
        uf: this.uf,
        complemento: this.complemento
      };
      //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
      this.tmaService.addNovoEndereco(customParams).subscribe((qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          this.modoNE = false;
          this.carregarEnderecos();
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao criar ao cadastrar este endereço. Tente novamente", iconAlerta: 'warning' }
          })
        }
      },
        (error) => {
          this.hideCL = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }
    else{
      //obter o endereco selecionado (id algo assim)
      //consultar se cidade e uf do endereço selecionado é o mesmo do utilizado ao entrar a loja
      //caso seja diferente, consultar com o id da loja se ela atende esse novo local
      //malding - krai q porra
      console.log(this.arrMeusEnderecos.find(x => x.Id == this.itenFavorito).Cidade);
      if(this.tmaService.shopCidade.toLowerCase() != this.arrMeusEnderecos.find(x => x.Id == this.itenFavorito).Cidade){
        //verificar se loja atual atende cidade escolhida
        //caso negativo - alert
        const cidadeInc = this.dialog.open(AlertaSimplesDialog, {
          //width: '300px',
          data: {tituloAlerta: "Aviso", textoAlerta: "Desculpe, ainda não atendemos este endereço. Escolha outro endereço na cidade de <b>" + this.tmaService.shopCidade + "</b> para continuar", textoConfirm: "Ok"}
        });
        return;
      }
      else{
        this.tmaService.shopEnderecoEntrega = [];
        this.tmaService.shopEnderecoEntrega.push(this.arrMeusEnderecos.find(x => x.Id == this.itenFavorito));
        this.tmaService.paginaAnterior = 'shopping/endereco';
        this.router.navigate(['/shopping/checkout']);

      }

      //redirecionar para checkout
      // if(this.itenFavorito == ''){

      // }
      // else{
      //   this.router.navigate(['/shopping/checkout']);
      // }
      

    }


  }

  modifiers(s: any): any{
    var r=s.toLowerCase();
    r = r.replace(new RegExp("\\s", 'g'),"-");
    r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
    r = r.replace(new RegExp("æ", 'g'),"ae");
    r = r.replace(new RegExp("ç", 'g'),"c");
    r = r.replace(new RegExp("[èéêë]", 'g'),"e");
    r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
    r = r.replace(new RegExp("ñ", 'g'),"n");                            
    r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
    r = r.replace(new RegExp("œ", 'g'),"oe");
    r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
    r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
    r = r.replace(new RegExp("\\W", 'g'),"-");
    return r;
};

  voltar() : void{
    if(this.modoNE){
      this.modoNE = false;
      this.novoEnd = false;
    }
    else{
      this.router.navigate(['/shopping/carrinho']);
    }
    
  }
}
